module.exports = __webpack_public_path__ + "img/16-doc-implantados-lista.93fdffe2.png";